/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Why does GC content matter?`)
};

const es_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`¿Por qué es importante el contenido GC?`)
};

const de_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Warum ist der GC-Gehalt wichtig?`)
};

const nl_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Waarom is GC-gehalte belangrijk?`)
};

const fr_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pourquoi le contenu GC est-il important ?`)
};

const it_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Perché il contenuto GC è importante?`)
};

const pt_br2_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Por que o conteúdo GC importa?`)
};

const pt_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Porque é que o conteúdo GC importa?`)
};

const ja_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`GC含量が重要なのはなぜですか？`)
};

const zh_gc_faq_q2 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`为什么 GC 含量很重要？`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const gc_faq_q2 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.gc_faq_q2(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("gc_faq_q2", locale)
	if (locale === "en") return en_gc_faq_q2(inputs)
	if (locale === "es") return es_gc_faq_q2(inputs)
	if (locale === "de") return de_gc_faq_q2(inputs)
	if (locale === "nl") return nl_gc_faq_q2(inputs)
	if (locale === "fr") return fr_gc_faq_q2(inputs)
	if (locale === "it") return it_gc_faq_q2(inputs)
	if (locale === "pt-BR") return pt_br2_gc_faq_q2(inputs)
	if (locale === "pt") return pt_gc_faq_q2(inputs)
	if (locale === "ja") return ja_gc_faq_q2(inputs)
	return zh_gc_faq_q2(inputs)
};